import { Component, EventEmitter, Input, Output } from "@angular/core";

import { DocumentPaButton } from '../../entities/document-pa-button';

import { ButtonActions } from '../../../../app.constants';

@Component({
	selector: 'document-pa-step-actions',
	templateUrl: 'document-pa-step-actions.html',
	styleUrls: ['document-pa-step-actions.css'],
})
export class DocumentPaStepActionsComponent {
	
	@Input() documentPaButtons!: DocumentPaButton[];
	
	@Output() onButtonPressed = new EventEmitter<ButtonActions>();

	buttonActions: typeof ButtonActions = ButtonActions;
	
	emitEvent(dpaButton: DocumentPaButton, event: Event) {
		this.onButtonPressed.emit(dpaButton.action);
	}

}